import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

import { immigrationCleanByRules } from '@/store/party/partials/party-edit/helpers/pe-immigration-status-card'

export const PEImmigrationStatusHistoriesCardActions = {
  initPeImmigrationStatusHistoriesCard: ({ commit }, index) => {
    commit('setPeImmigrationStatusHistoriesCardLock', { index, lock: true })
  },
  peImmigrationStatusHistoriesCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    const cleanSection = immigrationCleanByRules(section)

    return axiosRequest.
      post('/party_characteristics', {
        immigration_statuses: {
          party_id: party.id,
          immigration_status: cleanSection.immigration_status,
          admission_category: cleanSection.admission_category,
          niv_type: cleanSection.niv_type,
          certificate_number: cleanSection.certificate_number,
          naturalization_certificate_number: cleanSection.naturalization_certificate_number,
          i_94: cleanSection.i_94,
          immigration_status_other: cleanSection.immigration_status_other,
          date_expires: cleanSection.date_expires,
          date_expires_format: cleanSection.date_expires_format,
          date_expires_uncertain: cleanSection.date_expires_uncertain,
          date_obtained: cleanSection.date_obtained,
          date_obtained_format: cleanSection.date_obtained_format,
          date_obtained_uncertain: cleanSection.date_obtained_uncertain,
          place_obtained: cleanSection.place_obtained,
          notes: cleanSection.notes,
          current: false,
        },
      }).
      then(({ data }) => {
        commit('setPeImmigrationStatusHistoriesCardLock', { index: 'new', lock: true })
        commit('setPeImmigrationStatusHistoriesCardLock', { index: data.id, lock: true })
        commit('pePatchCharacteristicNew', {
          characteristic: 'immigration_status_histories',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peImmigrationStatusHistoriesCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/party_characteristics/immigration_statuses/${section.id}`).
      then(({ data }) => {
        commit('setPeImmigrationStatusHistoriesCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'immigration_status_histories',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peImmigrationStatusHistoriesCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    const cleanSection = immigrationCleanByRules(section)

    return axiosRequest.
      patch(`/party_characteristics/${id}`, {
        immigration_statuses: {
          party_id: party.id,
          immigration_status: cleanSection.immigration_status,
          admission_category: cleanSection.admission_category,
          niv_type: cleanSection.niv_type,
          certificate_number: cleanSection.certificate_number,
          naturalization_certificate_number: cleanSection.naturalization_certificate_number,
          i_94: cleanSection.i_94,
          immigration_status_other: cleanSection.immigration_status_other,
          date_expires: cleanSection.date_expires,
          date_expires_format: cleanSection.date_expires_format,
          date_expires_uncertain: cleanSection.date_expires_uncertain,
          date_obtained: cleanSection.date_obtained,
          date_obtained_format: cleanSection.date_obtained_format,
          date_obtained_uncertain: cleanSection.date_obtained_uncertain,
          place_obtained: cleanSection.place_obtained,
          notes: cleanSection.notes,
          current: cleanSection.current,
        },
        id,
      }).
      then(({ data }) => {
        commit('setPeImmigrationStatusHistoriesCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'immigration_status_histories',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peImmigrationStatusHistoriesCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/party_characteristics/${id}`, {
        data: {
          immigration_statuses: {
            party_id: party.id,
          },
          id,
        },
      }).
      then(({ data }) => {
        const immigrationStatuses = data.immigration_statuses || []

        commit('setPeImmigrationStatusHistoriesCardLock', { index, lock: true })
        commit('pePatchParty', {
          immigration_status_histories: immigrationStatuses.filter(status => !status.current),
        })
      }).
      catch(handleError)
  },
  peImmigrationStatusHistoriesCardAddSection: ({ commit }) => {
    commit('setPeImmigrationStatusHistoriesCardLock', { index: 'new', lock: false })
    commit('addPeImmigrationStatusHistoriesCardSection', {
      id: null,
      immigration_status: null,
      admission_category: null,
      niv_type: null,
      certificate_number: null,
      naturalization_certificate_number: null,
      i_94: null,
      immigration_status_other: null,
      date_expires: null,
      date_expires_format: null,
      date_expires_uncertain: null,
      date_obtained: null,
      date_obtained_format: null,
      date_obtained_uncertain: null,
      place_obtained: null,
      notes: null,
      current: false,
    })
  },
}

export const PEImmigrationStatusHistoriesCardMutations = {
  setPeImmigrationStatusHistoriesCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.ImmigrationStatusHistoriesCard) {
      Vue.set(state.partyEdit.partySections, 'ImmigrationStatusHistoriesCard', {})
    }
    Vue.set(state.partyEdit.partySections.ImmigrationStatusHistoriesCard, index, lock)
  },
  addPeImmigrationStatusHistoriesCardSection: (state, section) => {
    state.partyEdit.party.immigration_status_histories.push(section)
  },
  peImmigrationStatusHistoriesCardCreateUndo: state => {
    const list = state.partyEdit.party.immigration_status_histories
    const index = list.findIndex(status => status.id === null)
    if (index !== -1) list.splice(index, 1)

    Vue.set(state.partyEdit.partySections.ImmigrationStatusHistoriesCard, 'new', true)
  },
}

export const PEImmigrationStatusHistoriesCardGetters = {
  peImmigrationStatusHistoriesCardLock: state => index => state.partyEdit.partySections.ImmigrationStatusHistoriesCard[index],
  peImmigrationStatusHistoriesCardHasNewSection: (_, getters) => !!getters.
    peParty.
    immigration_status_histories?.
    find(status => status.id === null),
}
